import React from "react";
import { DialogTitle, IconButton, Typography, useTheme } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
const BootstrapDialogTitle = ({ title, subtitle, onClose, ...other }) => {
  const theme = useTheme();

  return (
    <DialogTitle
      {...other}
      sx={{
        // padding: theme.spacing(2),
        // paddingBottom: subtitle ? theme.spacing(1) : theme.spacing(2),
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexDirection: "row",
        gap: 1,
        background: "linear-gradient(90deg, #225B27, #053608)",
        borderTopLeftRadius: "20px",
        borderTopRightRadius: "20px",
      }}
    >
      <div>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            textTransform: "capitalize",
            padding: 0,
            color: "#fff",
          }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography
            variant="body2"
            sx={{ color: theme.palette.text.secondary, fontSize: 13 }}
          >
            {subtitle}
          </Typography>
        )}
      </div>

      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          color: "#fff",
          alignSelf: "flex-start",
          marginTop: "2px",
          padding: 0,
          border: "1px solid rgb(252, 252, 252)",
          p: "4px",
        }}
      >
        <CloseIcon sx={{ fontSize: 20, color: "#fff", }} />
      </IconButton>
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

const DialogHeader = ({ title, subtitle, handleClose }) => {
  return (
    <BootstrapDialogTitle
      title={title}
      subtitle={subtitle}
      onClose={handleClose}
    />
  );
};

export default DialogHeader;
